export type BlogCategory =
  | "All"
  | "Pricing & Reviews"
  | "Company Updates"
  | "Voice AI Guides"
  | "Tool Comparisons"
  | "AI Use Cases";

export const BLOG_CATEGORIES: BlogCategory[] = [
  "All",
  "Voice AI Guides",
  "Company Updates",
  "Pricing & Reviews",
  "Tool Comparisons",
  "AI Use Cases",
];

export interface BlogAuthor {
  name: string;
  role: string;
  avatarText: string;
  avatarColor: string;
  bio: string;
}

export interface BlogSection {
  id: string;
  title: string;
  content: string;
  bulletPoints?: string[];
  table?: {
    headers: string[];
    rows: string[][];
  };
  codeBlock?: {
    language: string;
    code: string;
  };
  callout?: {
    type: "info" | "warning" | "security";
    text: string;
  };
}

export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  category: Exclude<BlogCategory, "All">;
  publishedDate: string;
  readTime: string;
  featured?: boolean;
  author: BlogAuthor;
  coverGradient: string;
  coverIllustration: "security" | "funding" | "hipaa" | "gateway" | "ecommerce" | "compare" | "pricing" | "latency";
  tableOfContents: { id: string; title: string }[];
  executiveSummary: string;
  sections: BlogSection[];
  featuredImage?: string | null;
  featuredImageAlt?: string | null;
  contentHtml?: string | null;
  contentJson?: any;
  relatedSlugs: string[];
  keyTakeaways: string[];
}

export const BLOG_AUTHORS: Record<string, BlogAuthor> = {
  shubham: {
    name: "Shubham Jadhav",
    role: "Technology & AI Contributor",
    avatarText: "SJ",
    avatarColor: "from-foreground to-foreground/80",
    bio: "Contributes technical insights and analysis on artificial intelligence, conversational agents, and workflow automation for Quto AI.",
  },
  suryabhan: {
    name: "Suryabhan Singh",
    role: "AI & Technology Contributor",
    avatarText: "SS",
    avatarColor: "from-foreground to-foreground/80",
    bio: "Writes on modern conversational AI, intelligent voice systems, and enterprise automation practicalities for Quto AI.",
  },
  lily: {
    name: "Lily Singhal",
    role: "Editorial Contributor",
    avatarText: "LS",
    avatarColor: "from-foreground to-foreground/80",
    bio: "Writes on AI automation, customer experience, and conversational technology strategies for Quto AI.",
  },
  mohit: {
    name: "Mohit Mittal",
    role: "Technology & AI Contributor",
    avatarText: "MM",
    avatarColor: "from-foreground to-foreground/80",
    bio: "Focuses on enterprise technology trends, conversational systems, and applied AI workflows for Quto AI.",
  },
};

export const BLOG_POSTS: BlogPost[] = [];
